import bridge from '@utiles/bridge';
import { getHrefParam } from '@store/ultile';

const gameId = getHrefParam('gameId');
export const showNewTerms = [].includes(+gameId);

export default {
  props: {
    popupName: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      showNewTerms,
      isH5: getHrefParam('isH5') == 1
    };
  },
  created() {
    window.setPhoneReturnCb(true, () => {
      this.closeTerms();
    });
  },
  beforeDestroy() {
    window.setPhoneReturnCb(false);
  },
  methods: {
    closeTerms() {
      window?.passportv2DataLayer?.push({
        eventName: 'click_button',
        eventValue: '',
        eventType: 'exitGameBtn',
        eventReason: this?.popupName || ''
      });
      bridge.callSdkMethod('exitApp');
    }
  }
};
